import { ComponentProps } from "react";

interface ChevronIconProps extends ComponentProps<"svg"> {
  color?: string;
  style?: React.CSSProperties;
  width?: number;
  height?: number;
}

export default function ChevronIcon(props: ChevronIconProps) {
  const { color = "currentColor", style, width = 10, height = 6, ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 10 6"
      fill="none"
      {...rest}
      style={style}
    >
      <path
        d="M0.999143 5.19141L5.18902 1.00152L9.37891 5.19141"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
